<template>
  <div>
    <div
      v-if="$vuetify.breakpoint.xsOnly"
      class="background-color-white pl-6 py-2"
    >
      About
    </div>
    <Title v-if="$vuetify.breakpoint.smAndUp" :text="'About'" />
    <v-container fluid class="px-0 pb-sm-3 px-sm-3 pt-0">
      <v-row class="flex-md-row-reverse" no-gutters>
        <v-col class="pb-3 pl-md-3" cols="12" md="4">
          <StoreTitle />
        </v-col>

        <v-col class="pb-3 pr-md-3" cols="12" md="8">
          <StoreHours />
        </v-col>
      </v-row>

      <v-row class="flex-md-row-reverse" no-gutters>
        <v-col cols="12" md="4" class="pb-3 pb-md-0 pl-md-2 pt-0 pt-md-3">
          <StoreDescription />
        </v-col>
        <v-col
          cols="12"
          md="8"
          class="pb-3 pb-md-0 pr-sm-3 pr-md-4 pt-md-3 py-0"
        >
          <div
            class="background-color-white full-height min-height pa-2 rounded-lg"
          >
            <!--
              GoogleMap can't be conditionally rendered
            -->
            <GoogleMap />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GoogleMap from "@/components/GoogleMap.vue";
import Title from "@/components/UI/Title.vue";
import StoreTitle from "@/components/About/StoreTitle.vue";
import StoreDescription from "@/components/About/StoreDescription.vue";
import StoreHours from "@/components/About/StoreHours.vue";
export default {
  name: "AboutView",
  components: { GoogleMap, Title, StoreTitle, StoreDescription, StoreHours },
};
</script>

<style scoped>
.min-height {
  min-height: 388px;
}
</style>
